import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import MainLayout from '../layout/MainLayout.vue'
import LoginView from '../views/LoginView.vue'
import ResetPassword from '../views/ResetPassword.vue'
import TenantSelect from '../views/TenantSelect.vue'
import dashboardRoutes from './modules/dashboard'
import systemRoutes from './modules/system'
import authorizationRoutes from './modules/authorization'
import deviceIotRoutes from './modules/deviceIot'
import maintenanceRoutes from './modules/maintenance'
import controlRoutes from './modules/control'
import sleepMonitorRoutes from './modules/sleepMonitor'
import deviceSimulatorRoutes from './modules/deviceSimulator'
import statisticsRoutes from './modules/statistics'
import aiAgentRoutes from './modules/aiAgent'
import mediaLibraryRoutes from './modules/mediaLibrary'
import businessOrchestrationRoutes from './modules/businessOrchestration'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: { helpKey: 'login' }
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPassword,
      meta: { helpKey: 'reset-password' }
    },
    {
      path: '/tenant-select',
      name: 'tenant-select',
      component: TenantSelect,
      meta: { helpKey: 'tenant-select' }
    },
    {
      path: '/',
      component: MainLayout,
      redirect: '/dashboard',
      children: [
        ...dashboardRoutes,
        ...systemRoutes,
        ...authorizationRoutes,
        ...deviceIotRoutes,
        ...maintenanceRoutes,
        ...controlRoutes,
        ...sleepMonitorRoutes,
        ...deviceSimulatorRoutes,
        ...statisticsRoutes,
        ...aiAgentRoutes,
        ...mediaLibraryRoutes,
        ...businessOrchestrationRoutes
      ]
    }
  ]
})

const publicPaths = new Set(['/login'])

router.beforeEach(async (to) => {
  if (publicPaths.has(to.path)) return true

  const authStore = useAuthStore()
  if (!authStore.initialized) {
    authStore.initAuth()
  }

  if (!authStore.isAuthenticated) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }

  try {
    await authStore.ensureValidAccessToken()
  } catch {
    return { path: '/login', query: { redirect: to.fullPath } }
  }

  // 登录身份路由（workflow 05 login-identity-routing）：
  // ① 无任何岗位 → 禁止进入后台（提示无权限）
  const nonGlobalTenants = authStore.availableTenants.filter((t) => !t.is_global && t.tenant_id)
  const hasGlobalRole = authStore.availableTenants.some((t) => t.is_global)
  if (authStore.availableTenants.length === 0 && to.path !== '/tenant-select') {
    return { path: '/tenant-select', query: { redirect: to.fullPath, blocked: 'no-membership' } }
  }
  // ② currentTenantId 失效（岗位被移除）→ 清除并重选
  if (
    authStore.currentTenantId &&
    !nonGlobalTenants.some((t) => t.tenant_id === authStore.currentTenantId) &&
    !hasGlobalRole
  ) {
    authStore.currentTenantId = null
  }
  // ③ 多租户且未确定当前租户 → 强制进入租户选择页（自身页面除外）
  if (nonGlobalTenants.length > 1 && !authStore.currentTenantId && to.path !== '/tenant-select') {
    return { path: '/tenant-select', query: { redirect: to.fullPath } }
  }

  return true
})

export default router
